import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-shell',
  templateUrl: './login-shell.component.html',
  styleUrls: ['./login-shell.component.scss']
})
export class LoginShellComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
